<template>
  <div class="form-field-container">
    <div class="h-full form-field" :class="[error && 'error']">
      <textarea
        :id="fieldId"
        :placeholder="placeholder"
        :value="inputValue"
        class="h-40 py-4 resize-none form-input"
        :class="[leftIcon && 'left', rightIcon && 'right']"
        @input="handleInput"
      >
      </textarea>
      <label :for="fieldId" :class="[labelPosition && `form-label-${labelPosition}`]">
        {{ label }}
      </label>

      <!-- use slots to add icons to input field -->
      <span v-if="leftIcon" class="form-field-icon left"><slot name="left"></slot></span>
      <span v-if="rightIcon" class="form-field-icon right"><slot name="right"></slot></span>
    </div>
    <div v-if="error" class="text-xs font-semibold text-red-500">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'VFormTextarea',
  data() {
    return {
      inputValue: '',
    };
  },
  props: {
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    error: {
      type: String,
      required: false,
    },
    initialValue: {
      type: [String, Number],
      required: false,
      default: '',
    },
    labelPosition: {
      type: String,
      required: false,
      default: 'top',
    },
    leftIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
    rightIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    inputValue(val) {
      this.$emit('update', val);
    },
    initialValue(val) {
      this.inputValue = val;
    },
  },
  computed: {
    fieldId() {
      return uuidv4();
    },
  },
  methods: {
    handleInput(event) {
      const value = event.target.value;
      this.inputValue = value;
    },
  },
  mounted() {
    // ensure that input values is always updated with the initial value
    this.inputValue = this.initialValue;
  },
};
</script>
